import { gql } from '@apollo/client';

import { ServerFiscalYearType } from '../../types/fiscalYear';

// QUERIES

export type FetchFiscalYearsType = {
	fiscalYears: {
		count: number;
		items: ServerFiscalYearType[];
		limit: number;
		offset: number;
	};
};

export const FETCH_FISCAL_YEARS = gql`
	query FiscalYears($search: String, $page: Page!, $orderBy: OrderBy) {
		fiscalYears(search: $search, page: $page, orderBy: $orderBy) {
			count
			items {
				code
				id
				name
				startDate
				endDate
			}
			limit
			offset
		}
	}
`;

export type FetchFiscalYearsByCustomerFileType = {
	fiscalYearsByCustomerFile: {
		count: number;
		items: ServerFiscalYearType[];
		limit: number;
		offset: number;
	};
};

export const FETCH_FISCAL_YEARS_BY_CUSTOMER_FILE = gql`
	query FiscalYearsByCustomerFile($customerFileId: ID!, $search: String, $page: Page!, $orderBy: OrderBy) {
		fiscalYearsByCustomerFile(customerFileId: $customerFileId, search: $search, page: $page, orderBy: $orderBy) {
			count
			items {
				code
				id
				name
				startDate
				endDate
			}
			limit
			offset
		}
	}
`;

export type FetchFiscalYearsByUnprocessedMissionsAndCustomerFileType = {
	brochure_fiscalYearsByUnprocessedMissionsAndCustomerFile: {
		count: number;
		items: Omit<ServerFiscalYearType, 'code' | 'isClosed'>[];
		limit: number;
		offset: number;
	};
};

export const FETCH_FISCAL_YEARS_BY_UNPROCESSED_MISSIONS_AND_CUSTOMER_FILE = gql`
	query brochure_fiscalYearsByUnprocessedMissionsAndCustomerFile(
		$customerFileId: ID!
		$search: String
		$page: Page!
		$orderBy: OrderBy
	) {
		brochure_fiscalYearsByUnprocessedMissionsAndCustomerFile(
			customerFileId: $customerFileId
			search: $search
			page: $page
			orderBy: $orderBy
		) {
			count
			items {
				id
				name
				startDate
				endDate
			}
			limit
			offset
		}
	}
`;

export type FetchAllFiscalYearsType = {
	fiscalYearsWithoutPagination: ServerFiscalYearType[];
};

export const FETCH_ALL_FISCAL_YEARS = gql`
	query FiscalYearsWithoutPagination {
		fiscalYearsWithoutPagination {
			endDate
			isClosed
			startDate
		}
	}
`;
